import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {MonthlyStatementFilter} from './interfaces/monthly-statement-filter.interface';

@Injectable({
    providedIn: 'root',
})
export class FinancialService {
    /**
     * API URL
     * @private
     */
    private readonly apiUrl = environment.apiUrl;

    /**
     * Constructor
     * @param http - Angular Http Client
     */
    constructor(private http: HttpClient) {
    }

    /**
     * [GET] List extracts of company
     * @param idCompany - Company id
     */
    public extracts(idCompany: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/financeiro/extratos/${idCompany}`);
    }

    /**
     * [GET] Company balance
     * @param idCompany - Company id
     */
    public balance(idCompany: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/financeiro/saldo/${idCompany}`);
    }

    /**
     * [GET] List of plans to company
     * @param idCompany - Company id
     */
    public plans(idCompany: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/financeiro/planos/${idCompany}`);
    }

    /**
     * [POST] Update plan
     * @param payload Update plan payload
     */
    public updatePlan(payload: { idEmpresa: string, idPrecoBase: string }): Observable<any> {
        return this.http.post(`${this.apiUrl}/financeiro/atualizar-plano/`, payload);
    }

    /**
     * [POST] Monthly statement
     * @param filter Filter payload
     */
    public monthlyStatement(filter: MonthlyStatementFilter): Observable<any> {
        return this.http.post(`${this.apiUrl}/financeiro/extrato-mensal/`, filter);
    }
}
